import type { MyBetsState, SearchBetsQuery } from '../../types/myBets';

const betsRequested = (state: MyBetsState, payload: SearchBetsQuery): MyBetsState => ({
  ...state,
  bets: payload.fromRecord === 1 ? [] : state.bets,
  cashoutQuotes: payload.fromRecord === 1 ? {} : state.cashoutQuotes,
  cashedOut: payload.fromRecord === 1 ? {} : state.cashedOut,
  isFetching: true,
  isErroneous: false
});

export default betsRequested;
